import { gql } from '@apollo/client';

export const CREATE_DIRECTORY = gql`
  mutation CreateDirectory($input: DirectoryInput!) {
    createDirectory(input: $input) {
      id
      name
      slug
      values {
        id
        name
        description
        directory
      }
    }
  }
`;

export const UPDATE_DIRECTORY = gql`
  mutation UpdateDirectory($id: ID!, $input: DirectoryInput!) {
    updateDirectory(id: $id, input: $input) {
      id
      name
      slug
      values {
        id
        name
        description
        directory
      }
    }
  }
`;
